import { render, staticRenderFns } from "./seacherDetails.vue?vue&type=template&id=a5aa112a&"
import script from "./seacherDetails.vue?vue&type=script&lang=js&"
export * from "./seacherDetails.vue?vue&type=script&lang=js&"
import style0 from "./seacherDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports